import { OPEN_DISPATCH_CONFIG_MODAL, CLOSE_DISPATCH_CONFIG_MODAL, GET_DISPATCH_CONFIG_LIST, DISPATCH_CONFIG_UPDATED, DISPATCH_CONFIG_CREATED, DISPATCH_CONFIG_SET_ACTIVE, DISPATCH_CONFIG_DELETE } from './dispatch.actionsTypes'

export default function dispatch(state = {}, action) {
    let newState = Object.assign({}, state);
	switch (action.type) {
        case GET_DISPATCH_CONFIG_LIST:
            return{
                ...newState,
                configList: action.areaList
            }
		// case ACTION_TYPES.GET_DISPATCHING_DATA:
		// 	return {
		// 		...newState,
		// 		dispatching: action.data
		// 	};
		case OPEN_DISPATCH_CONFIG_MODAL:
			const returnObj = {
				...newState,
				showModal: true
			}
			if(action.selectedDispatch){
				returnObj.selectedDispatch = action.selectedDispatch
			}
			return returnObj
		case CLOSE_DISPATCH_CONFIG_MODAL:
            delete newState.selectedDispatch
			return {
				...newState,
					showModal: false
			}
        case DISPATCH_CONFIG_CREATED:
            newState.configList.push(action.config)
            return newState;
        case DISPATCH_CONFIG_UPDATED:
            const configList = newState.configList.map(item => {
                if(item._id === action.id) {
                    return action.config
                }
                return item;
            });
            return {
                ...newState,
                configList
            };
        case DISPATCH_CONFIG_SET_ACTIVE:
            const list = newState.configList.map(item => {
                if(item._id == action.id) {
                    item.is_selected = true
                } else {
                    item.is_selected = false
                }
                return item;
            });
            return {
                ...newState,
                configList: list
            };
        case DISPATCH_CONFIG_DELETE:
            return {
                ...newState,
                configList: newState.configList.filter(e => e._id != action.id)
            }
		default:
			return state;
	}
}